import { useMemo } from 'react';
import { makeBEM, makeRootClassName } from '../../../utils';
export var usePageNavigationClassNames = function usePageNavigationClassNames(classPrefix, className) {
  return useMemo(function () {
    var pageButtonClassName = makeBEM(classPrefix, 'PageButton');
    return {
      Root: makeRootClassName(classPrefix, className),
      PageButton: pageButtonClassName,
      Buttons: makeBEM(classPrefix, 'Buttons'),
      ArrowButton: "".concat(makeBEM(classPrefix, 'ArrowButton'), " ").concat(pageButtonClassName),
      PageSize: makeBEM(classPrefix, 'PageSize'),
      PageSizeSelector: makeBEM(classPrefix, 'PageSizeSelector')
    };
  }, [classPrefix, className]);
};